import { render, staticRenderFns } from "./sgroup.vue?vue&type=template&id=101fcf10&"
import script from "./sgroup.vue?vue&type=script&lang=js&"
export * from "./sgroup.vue?vue&type=script&lang=js&"
import style0 from "./sgroup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports